import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { formatBenchmarkValue, getDetailScalePercent } from './utils'
import { getMetricIcon } from './metric-icons'
import { BenchmarkStatusChip } from './benchmark-chips'
import BenchmarkScaleTrack, {
  BenchmarkScaleTick,
} from './benchmark-scale-track'
import { BENCHMARK_PEER_LABEL, getCoachBenchmarksPath } from './constants'

const BenchmarkMetricRow = ({ metric, classes }) => {
  const coachDisplay = formatBenchmarkValue(metric.coachValue, metric.unit)
  const medianDisplay = formatBenchmarkValue(metric.medianValue, metric.unit)
  const medianPercent = getDetailScalePercent(metric.medianValue, metric)
  const MetricIcon = getMetricIcon(metric.id)

  return (
    <Box
      component={RouterLink}
      to={getCoachBenchmarksPath(metric.id)}
      className={classes.metricRow}
    >
      <Box className={classes.metricLabelCell}>
        {MetricIcon ? (
          <Box className={classes.metricIconCircle} aria-hidden>
            <MetricIcon />
          </Box>
        ) : null}
        <Box className={classes.metricLabelText}>
          <Typography className={classes.metricLabel}>
            {metric.label}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.metricVisual}>
        <BenchmarkScaleTrack metric={metric}>
          <BenchmarkScaleTick percent={medianPercent} />
        </BenchmarkScaleTrack>
      </Box>

      <Box className={classes.metricStats}>
        <Typography className={classes.metricValues}>
          You: {coachDisplay} | {BENCHMARK_PEER_LABEL}: {medianDisplay}
        </Typography>
        <BenchmarkStatusChip metric={metric} />
      </Box>
    </Box>
  )
}

BenchmarkMetricRow.propTypes = {
  metric: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    coachValue: PropTypes.number.isRequired,
    medianValue: PropTypes.number.isRequired,
    gettingStartedValue: PropTypes.number.isRequired,
    top10Value: PropTypes.number.isRequired,
    unit: PropTypes.oneOf(['percent', 'hours', 'currency']).isRequired,
    higherIsBetter: PropTypes.bool.isRequired,
  }).isRequired,
  classes: PropTypes.object.isRequired,
}

export default BenchmarkMetricRow
